import { createTheme, ThemeProvider } from "@mui/material/styles";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Homepage from "./pages/Homepage";

function App() {
  const muiTheme = createTheme({
    palette: {
      mode: "light",
    },
    typography: {
      fontFamily: 'Geist, "Helvetica Neue", Arial, sans-serif',
    },
  });
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider theme={muiTheme}>
          <Routes>
            <Route path="/:sessionId" element={<Homepage />} />
            <Route path="/" element={<Homepage />} />
          </Routes>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
